function DownArrowsIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_63067_38683)">
        <path
          d="M2 4.66602L6 8.66602L8.66667 5.99935L14 11.3327"
          stroke="#B21212"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0002 6.66602V11.3327H9.3335"
          stroke="#B21212"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_63067_38683">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DownArrowsIcon;
